import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FadeIn, Section, SectionTitle, Accent, pad2 } from './Shared';
import { Stars } from './HeaderSections';
import { OfferCard } from './CoreSections';
import { useCountdown } from '../hooks/useCountdown';
import { coachTestimonials } from '../data/testimonials';
import { faqs } from '../data/faqs';
import { ShieldCheck, Plus, Clock, Lock, CreditCard, ArrowRightIcon, MailIcon, AtSignIcon, MapPinIcon } from 'lucide-react';
export const Testimonials2 = () => <Section className="bg-slate-950" data-id="element-174" data-mp="13a4spyr151rp">
    <FadeIn data-id="element-175" data-mp="pgvpkftodchm">
      <SectionTitle sub={<span className="inline-flex flex-wrap items-center justify-center gap-2" data-id="element-177" data-mp="pgdieo5h5dux">
            <Stars size={14} data-id="element-178" data-mp="tgw9uh3gghwl" />
            <span className="font-semibold text-white" data-id="element-179" data-mp="tfuonjsq6f15">4,9/5</span>
            <span data-id="element-180" data-mp="1h70623ebdfdk">· +150 trenerów z całej Polski</span>
          </span>} data-id="element-176" data-mp="phf4dno13krf">
        Co mówią <Accent data-id="element-181" data-mp="1lzbejun4e9hq">trenerzy</Accent>
      </SectionTitle>
    </FadeIn>

    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-182" data-mp="31m4ivth9wujc">
      {coachTestimonials.map((t, i) => <FadeIn key={t.name} delay={Math.min(i * 0.05, 0.2)} data-id="element-183" data-mp="2wom9k1zcgdat" data-mpi={i}>
          <figure className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-id="element-184" data-mp="3bch29idcqhnw">
            <Stars data-id="element-185" data-mp="36m0o1w1pis0h" />
            <blockquote className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-186" data-mp="36lh8un3fyhq5">
              „{t.text}”
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-187" data-mp="3kbc9mxs4txss">
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${t.bg} text-xs font-bold text-white`} data-id="element-188" data-mp="3gasbprzqiq5l">
                {t.initials}
              </div>
              <div className="min-w-0" data-id="element-189" data-mp="3pbyxafh8qr5p">
                <p className="text-sm font-semibold leading-tight text-white" data-id="element-190" data-mp="3pd1j48zpi3er">{t.name}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500" data-id="element-191" data-mp="1zxu03n6x1ji0">
                  <MapPinIcon size={11} aria-hidden="true" data-id="element-192" data-mp="1uz8ybjc0mrrg" /> {t.location} · Zweryfikowany zakup
                </p>
              </div>
            </figcaption>
          </figure>
        </FadeIn>)}
    </div>
  </Section>;
export const Guarantee = () => <Section className="bg-slate-900/40" data-id="element-193" data-mp="7vr3mc6owt45">
    <FadeIn className="mx-auto grid max-w-4xl items-center gap-8 rounded-3xl border border-emerald-500/25 bg-emerald-500/[0.05] p-6 md:grid-cols-[auto_1fr] md:gap-12 md:p-12" data-id="element-194" data-mp="7upnvueqbig3">
      <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10 md:h-36 md:w-36" data-id="element-195" data-mp="hugngai5cnn1">
        <div className="text-center" data-id="element-196" data-mp="mr6xag3cyn00">
          <ShieldCheck size={36} className="mx-auto text-emerald-400" aria-hidden="true" data-id="element-197" data-mp="rk0213yttvc3" />
          <p className="mt-1 font-display text-2xl font-black italic leading-none text-white md:text-3xl" data-id="element-198" data-mp="vl3kly89e5h0">7 dni</p>
        </div>
      </div>
      <div className="text-center md:text-left" data-id="element-199" data-mp="10lr9oecxgc8l">
        <h2 className="font-display text-3xl font-black uppercase italic leading-[0.95] tracking-tight text-white md:text-5xl" data-id="element-200" data-mp="15jj013xxbqao">
          7 dni gwarancji — <span className="text-emerald-400" data-id="element-201" data-mp="1fohn1ozlt616">bez zbędnych pytań</span>
        </h2>
        <div className="mt-5 space-y-3 text-base leading-relaxed text-slate-300 md:text-lg" data-id="element-202" data-mp="1ao3m0qwf6wcn">
          <p data-id="element-203" data-mp="15oqp1dbu48wc">Otwórz tomy. Wykorzystaj je na swoich zajęciach.</p>
          <p className="text-lg font-semibold leading-snug text-white md:text-xl" data-id="element-204" data-mp="15r3fyfzkltlj">
            Jeśli w ciągu 7 dni to nie będzie to, czego oczekujesz: zwracamy 100% pieniędzy.
          </p>
          <p data-id="element-205" data-mp="1yg1yhe7luxrd">Bez formularzy. Bez kombinowania. Bez odsyłania od drzwi do drzwi.</p>
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-206" data-mp="1tgxsewfz9g59">
          Odsetek zwrotów: poniżej 2%
        </p>
      </div>
    </FadeIn>
  </Section>;
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-slate-950" data-id="element-207" data-mp="2h605dqzo2ktf">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-208" data-mp="2cdqn8x4smp1p">
        <FadeIn className="text-center lg:text-left" data-id="element-209" data-mp="2cbm79gtmdzl2">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl lg:text-5xl" data-id="element-210" data-mp="1wvfrptwgdc6z">
            Najczęściej zadawane <Accent data-id="element-211" data-mp="1nv0upxa4m8nn">pytania</Accent>
          </h2>
          <p className="mt-4 text-slate-400" data-id="element-212" data-mp="1nwc9es5410tj">
            Masz jeszcze wątpliwości? Napisz do nas:{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="font-medium text-sky-400 underline-offset-4 hover:underline" data-id="element-213" data-mp="1rxe2er8fogn2">
              soportecentershop95@gmail.com
            </a>
          </p>
        </FadeIn>
        <FadeIn delay={0.05} data-id="element-214" data-mp="2kne7aq2xptpx">
          <div className="divide-y divide-white/10 border-y border-white/10" data-id="element-215" data-mp="26u50mx6dfmb3">
            {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return <div key={faq.q} data-id="element-216" data-mp="2yl2sjz0wz2vi" data-mpi={i}>
                  <h3 data-id="element-217" data-mp="2yksyo0cr0bkj">
                    <button id={`faq-q-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 rounded-md" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} data-id="element-218" data-mp="2yjhy09elnjxn">
                      <span className="text-base font-semibold text-white md:text-lg" data-id="element-219" data-mp="11ogbc6l36y0l">{faq.q}</span>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-blue-600 text-white' : 'bg-white/5 text-slate-300'}`} aria-hidden="true" data-id="element-220" data-mp="wpvac4y0gab3">
                        <Plus size={16} data-id="element-221" data-mp="ixp53dwebnqf" />
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-222" data-mp="dz443c9bl00x">
                    {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-223" data-mp="1u9g5tarrzf34">
                        <p className="pb-5 pr-12 text-[15px] leading-relaxed text-slate-300 md:text-base" data-id="element-224" data-mp="2baknrj68veje">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 godz. tygodniowo na szukanie sesji',
    costo: '156 godz. rocznie'
  }, {
    sin: 'Zajęcia bez struktury',
    costo: 'Klienci, którzy rezygnują'
  }, {
    sin: 'Brak modyfikacji wg poziomu',
    costo: 'Nowe osoby nie wracają'
  }, {
    sin: 'Brak rocznego planu',
    costo: 'Wciąż te same obwody'
  }, {
    sin: 'Niedziele na szukaniu pomysłów',
    costo: 'Ten sam schemat co roku'
  }];
  return <Section className="bg-slate-900/40" data-id="element-225" data-mp="34739qtyqotj7">
      <FadeIn className="mx-auto max-w-3xl" data-id="element-226" data-mp="3460igkxi8p2r">
        <SectionTitle data-id="element-227" data-mp="348wluos4g5yl">
          Ile Cię kosztuje
          <br data-id="element-228" data-mp="2z6xhpcok550l" /> <Accent data-id="element-229" data-mp="2z77831dile6t">to, że go nie masz?</Accent>
        </SectionTitle>

        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-230" data-mp="2u9fhcaolvy47">
        <table className="w-full text-left" data-id="element-231" data-mp="2pifigzvxf5z2">
          <thead data-id="element-232" data-mp="2pgmclmt50ps4">
            <tr className="border-b border-white/10 bg-white/[0.04]" data-id="element-233" data-mp="2pg2ti2rr3vci">
              <th scope="col" className="w-1/2 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-slate-400 md:px-6 md:text-sm" data-id="element-234" data-mp="2lhdiuhy3krwk">
                Bez Treningu Funkcjonalnego 365
              </th>
              <th scope="col" className="w-1/2 border-l border-white/10 px-4 py-3.5 text-xs font-semibold uppercase tracking-wide text-white md:px-6 md:text-sm" data-id="element-235" data-mp="2bhwf462eoo38">
                Prawdziwy koszt
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5" data-id="element-236" data-mp="39g5kasab1wi">
            {costs.map(row => <tr key={row.sin} data-id="element-237" data-mp="3lfb8ze38fpqw">
                <td className="px-4 py-4 text-sm leading-snug text-slate-400 md:px-6 md:text-base" data-id="element-238" data-mp="3lg4bg2v5rt38">{row.sin}</td>
                <td className="border-l border-white/10 px-4 py-4 text-sm font-medium leading-snug text-red-400 md:px-6 md:text-base" data-id="element-239" data-mp="3qd4es60mihqn">
                  <span className="inline-flex items-start gap-1.5" data-id="element-240" data-mp="3bnoqqxsh8qen">
                    <ArrowRightIcon size={14} className="mt-0.5 shrink-0 md:mt-1" aria-hidden="true" data-id="element-241" data-mp="3ghsyhj9kh2gs" />
                    {row.costo}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-white md:text-xl" data-id="element-242" data-mp="2sq5ezmemwtoj">
          Twoje kolejne zajęcia mogą wyglądać inaczej…
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-slate-950 border-t border-white/5 !pb-28 md:!pb-24" data-id="element-243" data-mp="2a2d3581jn2lo">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-244" data-mp="2a4g42n48ig56">
        <FadeIn className="text-center lg:text-left" data-id="element-245" data-mp="2o3pipicsl271">
          <h2 className="font-display text-4xl font-black uppercase italic leading-[0.92] tracking-tight text-white md:text-6xl" data-id="element-246" data-mp="2j3bb21f3ru9j">
            Możesz <Accent data-id="element-247" data-mp="2x1hwgi2v81sb">improwizować</Accent> kolejne zajęcia — albo wejść na salę z gotowym planem.
          </h2>
          <p className="mt-4 font-display text-3xl font-black uppercase italic text-sky-400 md:text-4xl" data-id="element-248" data-mp="2t0pl9jafnmte">
            Wybór należy do Ciebie.
          </p>

          <div className="mt-8 inline-flex flex-col items-center gap-3 lg:items-start" data-id="element-249" data-mp="31t13ihve83ya">
            <p className="inline-flex items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-red-400" data-id="element-250" data-mp="3gqjxpzqub9d4">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-400" aria-hidden="true" data-id="element-251" data-mp="3btjt7t9n2eo4" />
              Ostatnia szansa · cena kończy się za
            </p>
            <p className="font-display text-5xl font-black tabular-nums leading-none tracking-tight text-white md:text-6xl" role="timer" aria-live="off" data-id="element-252" data-mp="395zcoqoq5f8t">
              {pad2(hours)}
              <span className="text-slate-600" data-id="element-253" data-mp="306vr9g234nr5">:</span>
              {pad2(minutes)}
              <span className="text-slate-600" data-id="element-254" data-mp="qytynbdjixr">:</span>
              {pad2(seconds)}
            </p>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-255" data-mp="3rxrtznuflc0p">
              Potem cena rośnie. Do tej już nie wrócimy.
            </p>
          </div>

          <ul className="mt-8 hidden flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400 lg:flex" data-id="element-256" data-mp="3nxrfk37c10tn">
            <li className="flex items-center gap-2" data-id="element-257" data-mp="3iz6e60gcgb3m"><Lock size={14} aria-hidden="true" data-id="element-258" data-mp="2ch1h5695hdal" /> 100% bezpieczna płatność</li>
            <li className="flex items-center gap-2" data-id="element-259" data-mp="27hy9rf5p6uzg"><Clock size={14} aria-hidden="true" data-id="element-260" data-mp="27gvk1ak42yl4" /> Dostęp w 5 minut</li>
            <li className="flex items-center gap-2" data-id="element-261" data-mp="n05vf7kxkrha"><ShieldCheck size={14} aria-hidden="true" data-id="element-262" data-mp="n17adn52hy4a" /> 7 dni gwarancji</li>
            <li className="flex items-center gap-2" data-id="element-263" data-mp="rzsazno8ejt9"><CreditCard size={14} aria-hidden="true" data-id="element-264" data-mp="rwml467s3dwh" /> Płatność w złotówkach · Bez ukrytych opłat</li>
          </ul>
        </FadeIn>

        <FadeIn delay={0.05} className="mx-auto w-full max-w-md" data-id="element-265" data-mp="10qsmcdkg9d2t">
          <OfferCard id="final-offer" footnote="Jednorazowa płatność · 7 dni gwarancji w cenie" data-id="element-266" data-mp="10t5che0d2tqy" />
        </FadeIn>

        <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-400 lg:hidden" data-id="element-267" data-mp="1ap8biazx2c9o">
          <li className="flex items-center gap-1.5" data-id="element-268" data-mp="1fobgjvfwcihn"><Lock size={13} aria-hidden="true" data-id="element-269" data-mp="1fpcrlzwwx4zd" /> 100% bezpieczna płatność</li>
          <li className="flex items-center gap-1.5" data-id="element-270" data-mp="1jqeuqrtya16m"><Clock size={13} aria-hidden="true" data-id="element-271" data-mp="1jpdabwr1o2c8" /> Dostęp w 5 minut</li>
          <li className="flex items-center gap-1.5" data-id="element-272" data-mp="3hgpxosam9ix0"><ShieldCheck size={13} aria-hidden="true" data-id="element-273" data-mp="3hhrab17a6dgu" /> 7 dni gwarancji</li>
          <li className="flex w-full items-center justify-center gap-1.5" data-id="element-274" data-mp="3li1hgh6t79xa"><CreditCard size={13} aria-hidden="true" data-id="element-275" data-mp="sm9ll7pknb6b" /> Płatność w złotówkach · Bez ukrytych opłat</li>
        </ul>
      </div>
    </Section>;
};
export const Footer = () => <footer className="border-t border-white/5 bg-slate-950 px-5 py-12 md:px-8" data-id="element-276" data-mp="nq1dufdpek96">
    <div className="mx-auto flex max-w-6xl flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-277" data-mp="11osofrtcxnsk">
      <div className="max-w-sm text-center md:text-left" data-id="element-278" data-mp="xnz1b0nqod0q">
        <p className="font-display text-xl font-black uppercase italic tracking-tight text-white" data-id="element-279" data-mp="1bkly93foz36n">
          Trening Funkcjonalny <Accent data-id="element-280" data-mp="16m15fp2rrls8">365™</Accent>
        </p>
        <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-slate-500" data-id="element-281" data-mp="1lbgsov33d936">
          od Center Shop Digital
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-400" data-id="element-282" data-mp="1gdf2lq7909i7">
          System gotowych zajęć nr 1 dla instruktorów i trenerów treningu
          funkcjonalnego. Bo świetne zajęcia nie powinny kosztować Cię każdej
          niedzieli w roku.
        </p>
      </div>
      <div className="flex flex-col items-center gap-3 text-sm text-slate-400 md:items-end" data-id="element-283" data-mp="28z3qcyl3ozk8">
        <a href="mailto:soportecentershop95@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-284" data-mp="2dxongp52334g">
          <MailIcon size={14} aria-hidden="true" data-id="element-285" data-mp="1zxma9g7p0xvj" /> soportecentershop95@gmail.com
        </a>
        <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-286" data-mp="23yfw841ks2ls">
          <AtSignIcon size={14} aria-hidden="true" data-id="element-287" data-mp="1q71f62r8abhd" /> centershop.digital
        </a>
      </div>
    </div>
    <div className="mx-auto mt-10 flex max-w-6xl flex-col items-center gap-3 border-t border-white/5 pt-6 text-xs text-slate-500 md:flex-row md:justify-between" data-id="element-288" data-mp="1v0ds3fmjotua">
      <p className="text-center md:text-left" data-id="element-289" data-mp="1l8hojp1owbio">
        © {new Date().getFullYear()} Center Shop Digital. Wszelkie prawa zastrzeżone.
        Ceny w złotych polskich (PLN).
      </p>
      <p className="flex gap-4" data-id="element-290" data-mp="1c931z0on8l3g">
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-291" data-mp="1c79w3nluu4wi">Regulamin</a>
        <a href="#" className="transition-colors duration-150 hover:text-white" data-id="element-292" data-mp="146kb5btpp8zk">Polityka prywatności</a>
      </p>
    </div>
  </footer>;